/* ============================================================
   pdp-sticky-atc.js  -  v3
   Controls the sticky Add to Cart bar (#md-sticky-atc).

   Rules (Wassim, 2026-08-06):
   1. The bar shows whenever the real Add to Cart button is NOT on
      screen, including on the first fold before any scrolling.
   2. WHERE it docks depends on which way the button went:
      - button is still BELOW the viewport (first fold)  -> dock BOTTOM
      - button has scrolled ABOVE the viewport            -> dock TOP
      The bar therefore never sits between the shopper and the content
      they are scrolling toward.

   The theme ships its own scroll-threshold handler that writes
   .is-visible on this bar. We do not edit it (it lives inside a 136KB
   section file). We re-assert our own state with a MutationObserver, so
   whichever handler runs last, ours wins.

   Positioning itself is CSS, driven by the .rq-dock-top /
   .rq-dock-bottom classes this file sets. See pdp-mobile.css section 6.

   Debugging: window.rqStickyAtc exposes the live state.

   Loaded from snippets/meta-tags.liquid, product pages only.
   ============================================================ */
(function () {
  'use strict';

  var BAR_ID = 'md-sticky-atc';
  var VISIBLE_CLASS = 'is-visible';
  var DOCK_TOP = 'rq-dock-top';
  var DOCK_BOTTOM = 'rq-dock-bottom';
  /* Treat the button as gone once it is within this many px of the
     bottom edge, which is roughly where the bottom-docked bar sits. */
  var BOTTOM_MARGIN = 90;

  var state = {
    version: 3,
    started: false,
    barFound: false,
    buttonFound: false,
    shouldShow: false,
    dock: 'bottom',
    reasserts: 0
  };
  window.rqStickyAtc = state;

  var bar = null;
  var button = null;
  var io = null;

  function findButton() {
    return (
      document.querySelector('product-info .product-form__submit') ||
      document.querySelector('[id^="ProductSubmitButton-"]') ||
      document.querySelector('.product__info-container .product-form__submit')
    );
  }

  /* Decide both questions in one place: should the bar show, and which
     edge should it come from. */
  function measure() {
    if (!button) return;
    var r = button.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    var onScreen = r.bottom > 0 && r.top < h - BOTTOM_MARGIN;

    state.shouldShow = !onScreen;

    if (!onScreen) {
      /* r.bottom <= 0 means the button is off the top of the screen,
         so the shopper has scrolled past it. Anything else means it is
         still below them. */
      state.dock = r.bottom <= 0 ? 'top' : 'bottom';
    }
  }

  function apply() {
    if (!bar) return;

    var wantTop = state.dock === 'top';
    var changed = false;

    if (bar.classList.contains(DOCK_TOP) !== wantTop) {
      bar.classList.toggle(DOCK_TOP, wantTop);
      changed = true;
    }
    if (bar.classList.contains(DOCK_BOTTOM) === wantTop) {
      bar.classList.toggle(DOCK_BOTTOM, !wantTop);
      changed = true;
    }
    if (bar.classList.contains(VISIBLE_CLASS) !== state.shouldShow) {
      bar.classList.toggle(VISIBLE_CLASS, state.shouldShow);
      changed = true;
    }

    if (changed) state.reasserts++;
  }

  function onScroll() {
    measure();
    apply();
  }

  function watchButton() {
    button = findButton();
    state.buttonFound = !!button;

    if (io) {
      io.disconnect();
      io = null;
    }
    if (!button) return;

    if (typeof IntersectionObserver === 'function') {
      /* The observer is only a trigger. measure() re-reads the rect so
         the show/dock decision stays in one place. */
      io = new IntersectionObserver(onScroll, {
        root: null,
        rootMargin: '0px 0px -' + BOTTOM_MARGIN + 'px 0px',
        threshold: 0
      });
      io.observe(button);
    }

    onScroll();
  }

  function start() {
    bar = document.getElementById(BAR_ID);
    state.barFound = !!bar;
    if (!bar) return;
    state.started = true;

    /* Start docked to the bottom so the very first paint, before any
       measurement, matches the first-fold rule. */
    bar.classList.add(DOCK_BOTTOM);

    watchButton();

    /* The theme's scroll handler also writes .is-visible. Re-assert our
       state whenever it does. The equality checks in apply() mean this
       cannot loop. */
    new MutationObserver(apply).observe(bar, {
      attributes: true,
      attributeFilter: ['class']
    });

    /* Registered after the theme's listener, so on a shared scroll
       event ours runs last. */
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    /* Dawn replaces the product info block on every variant change,
       which destroys the button we were observing. */
    var section =
      document.querySelector('product-info') ||
      document.querySelector('.product__info-container');
    if (section && section.parentNode) {
      new MutationObserver(function () {
        if (!button || !button.isConnected) watchButton();
      }).observe(section.parentNode, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
